import React, { Component } from 'react';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import services from '@C/Director/Utils/_utils/data';
import { TableGrid } from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';

const col = [
  {
    name: 'Shift name',
    key: 'shift',
  },
];

const enabledActions = [
  {
    action: 'Delete',
    roles: ['DIRECTOR'],
  },
  // {
  //   action: 'Edit',
  //   roles: ['DIRECTOR'],
  // },
];

export default class ShiftList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shiftList: [],
      loading: true,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getShiftList();
  }

  getShiftList = () => {
    services
      .getShiftList()
      .then((response) => {
        this.setState({
          shiftList: response.data.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm shift deletion',
      message: (
        <div>
          Are you sure you want to delete the <span>"{item.shift}"</span>
        </div>
      ),
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader();
    axios
      .delete(
        `${process.env.API_URL}/bunk/shifts/shifts-set/?shift_id=${item.uuid}`,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Shift deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        this.getShiftList();
      });
  };

  render() {
    const { shiftList } = this.state;
    return (
      <section className="widget full-width list-table">
        <header>
          <h3>Shift List </h3>
        </header>
        <main className="list-content">
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    <TableGrid
                      col={col}
                      row={shiftList}
                      pagination="disabled"
                      enableExport={false}
                      onEdit={this.props.onEdit}
                      onDelete={this.confirmDelete}
                      enabledActions={enabledActions}
                    />
                  </>
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}
